const baseURL = "https://api-gen-production.up.railway.app";
export const Endpoints = {
  UploadFile: "",
  JoinWaitlist: `${baseURL}/waitlist/join`,
};
